import { StatusUpgradeResponseDTO } from '@/core/api/dtos/response/accounts/statusUpgrade'
import { StatusUpgrade } from '@/core/api/entities/account/statusUpgrade'

import { SubscriptionMapper } from './subscriptionMapper'

export class StatusUpgradeMapper {
	static toEntity(dto: StatusUpgradeResponseDTO): StatusUpgrade {
		return StatusUpgrade.create({
			availableLicenses: dto.available_licenses,
			availableSubscriptions: dto.available_subscriptions,
			validBillingDate: dto.valid_billing_date,
			hasBoxes: dto.has_boxes,
			hasZones: dto.has_zones,
			hasBilling: dto.has_billing,
			boxMode: dto.box_mode,
			subscriptions: dto.subscriptions.data.map(SubscriptionMapper.toEntity),
			allSubscriptions: dto.all_subscriptions.data.map(
				SubscriptionMapper.toEntity
			),
		})
	}

	static toEntities(dtos: StatusUpgradeResponseDTO[]): StatusUpgrade[] {
		return dtos.map(this.toEntity)
	}
}
